<template>
    <div>
        <chart :chart-data="Data" @sendChart="chartApi = $event" :options="Options"></chart>
        <chart-legend class="chart-legend" :chart.sync="Data" @updateChartData="updateChart"></chart-legend>
    </div>
</template>

<script>
    import Scatter from "@/components/chart/scatter.vue";
    import Legend from "@/components/chart/legend.vue";
    export default {
        name: 'Scatter-Chart',
        components: {
            'chart': Scatter,
            'chart-legend': Legend
        },
        props: {
            Data: Object,
            Options: Object,
        },
        data() {
            return {
                chartApi: null
            }
        },
        methods: {
            updateChart(data) {
                this.chartApi.renderChart(data, this.Options);
            }
        }
    }
</script>